import { render, staticRenderFns } from "./ExportPostCost.vue?vue&type=template&id=0b794ab5&scoped=true&"
import script from "./ExportPostCost.vue?vue&type=script&lang=js&"
export * from "./ExportPostCost.vue?vue&type=script&lang=js&"
import style0 from "./ExportPostCost.vue?vue&type=style&index=0&id=0b794ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b794ab5",
  null
  
)

export default component.exports